import React from 'react';
import styled from 'styled-components';
import {labels} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import {uuid as uuidv4} from '../../../util/uuid';
import {alertIcWarning24px} from '@ey/motif-react-wrapper/assets/icons/index';
import Icon from '../BaseComponentWrappers/MotifIcon';

const ResourceWithLink = ({
	className = 'no-data-placeholder',
	placeholder = labels.noInformationAvailable,
	onPlaceholderClickConfig,
	showWarning,
	warningIcon,
	isNotClickable = false
}) => {
	const iconSrc = warningIcon || alertIcWarning24px;

	return (
		<StyledResourceWithLink key={uuidv4()} className={`StyledResourceWithLink ${className}`}>
			{showWarning && <Icon src={iconSrc} size="20" />}
			{Utility.createClickableText(placeholder, onPlaceholderClickConfig, isNotClickable)}
		</StyledResourceWithLink>
	);
};

export default ResourceWithLink;

const StyledResourceWithLink = styled.section`
	display: block;
	&.emptyContainer {
		.createClickableTextLink {
			margin: 0 var(--px-3);
		}
	}
	.motif-icon {
		margin-right: var(--spacing-small);
		display: flex;
		svg {
			path {
				fill: var(--orange-500);
			}
		}
	}
	.createClickableTextLink {
		cursor: pointer;
		color: var(--blue-600) !important;
		display: inline-flex;
	}
	.createRichTextElementSpanWrapper {
		font-size: var(--px-14);
		font-weight: 300;
		line-height: var(--px-20);
		.headingText {
			font-weight: 400;
		}
	}
`;
